import { Button } from '@mui/material';
import ExcelJS from 'exceljs';

const ExportExcelButton = (props) => {
  const {
    retrieveData,
    buttonLabel = 'Download Excel',
    onSuccess,
    onError,
    ...fields
  } = props;

  const exportToExcel = async () => {
  try {
    const [exportData, exportFilename] = await retrieveData();

    if (!Array.isArray(exportData) || exportData.length === 0) {
      onError("Não há dados para exportar!");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const headers = Object.keys(exportData[0] || {});
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(1, index + 1);
      cell.value = header;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
    });

    exportData.forEach((dataRow, rowIndex) => {
      const row = worksheet.getRow(rowIndex + 2);
      headers.forEach((header, colIndex) => {
        const cell = row.getCell(colIndex + 1);
        cell.value = dataRow[header] || '';
        cell.alignment = { horizontal: 'right' };

        if (header === "Cálculo 20S" && dataRow.Referência === "Total") {
          cell.numFmt = 'R$ #,##0.00';
        }

        if (header === "Cálculo 20S" && dataRow.Referência === "Valores Base") {
          cell.numFmt = '0.00%';
          cell.value = dataRow[header];
        }

        if (header === "Taxa Selic") {
          if (dataRow.Referência === "Valores Base") {
            cell.value = '';
          } else if (dataRow.Referência === "Total") {
            cell.numFmt = '0.00%';
            cell.value = dataRow[header] / 100;
          } else if (dataRow.Referência === undefined) {
            cell.value = '';
          } else {
            cell.numFmt = '0.00%';
            cell.value = dataRow[header] / 100;
          }
        }

        if (typeof dataRow[header] === 'number' && header !== "Taxa Selic" && header !== "Cálculo 20S") {
          cell.numFmt = 'R$ #,##0.00';
        }

        if (header === "Referência" && (dataRow[header] === "Valores Base" || dataRow[header] === "Total")) {
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center' };
        }
      });
    });

    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    });

    await workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${exportFilename}.xlsx`;
      link.click();
   
    });
  } catch (error) {
    console.error('Erro ao exportar para Excel:', error);
    onError('Ocorreu um erro ao gerar o arquivo Excel. Por favor, tente novamente.');
  }
};

  return (
    <Button
      onClick={exportToExcel}
      size="small"
      {...fields}
    >
      {buttonLabel}
    </Button>
  );
};

export default ExportExcelButton;